var LOCALE;
(function (LOCALE) {
    LOCALE["Vietnam"] = "vi-VN";
    LOCALE["Indonesia"] = "id-ID";
    LOCALE["Malaysia"] = "ms-MY";
    LOCALE["Cambodia"] = "km-KH";
    LOCALE["PhilippinesEnglish"] = "en-PH";
    LOCALE["PhilippinesTagalog"] = "tl-PH";
    LOCALE["Thailand"] = "th-TH";
    LOCALE["Myanmar"] = "my-MM";
    LOCALE["Taiwan"] = "zh-TW";
    LOCALE["India"] = "hi-IN";
    LOCALE["China"] = "zh-CN";
})(LOCALE || (LOCALE = {}));

export { LOCALE as L };
